import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";

export const STFormWrapper = styled.div`
  && {
    max-width: 500px;

    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
      margin-left: 25px;
    }

    ${theme.breakpoints.up("sm")} {
      min-width: 360px;
      margin-left: 35px;
    }
  }
`;
